import { z } from 'zod'

export const absenceSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
})

export type AbsenceSearch = z.infer<typeof absenceSearchSchema>

export const defaultAbsenceSearch: AbsenceSearch = {
  page: 1,
  pageSize: 25,
}
